<nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
  <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
    <a class="navbar-brand brand-logo mr-8" href="index.html"><img src="assets/images-removebg-preview.png"  class="mr-6" alt="logo"/></a>

        <a class="navbar-brand brand-logo-mini" href="index.html"><img src="assets/images-removebg-preview.png" alt="logo"/></a>

  </div>
  <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
    <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
      <span class="icon-menu"></span>
    </button>
    <ul class="navbar-nav mr-lg-2">
      <li class="nav-item nav-search d-none d-lg-block">
        <div class="input-group">
          <div class="input-group-prepend hover-cursor" id="navbar-search-icon">
            <span class="input-group-text" id="search">
              <i class="icon-search"></i>
            </span>
          </div>
          <input type="text" class="form-control" id="navbar-search-input" placeholder="Search now" aria-label="search"
            aria-describedby="search">
        </div>
      </li>
    </ul>
    <ul class="navbar-nav navbar-nav-right">
  <li class="nav-item dropdown">
    <a class="nav-link count-indicator dropdown-toggle" (click)="updateTimeDifference()" id="notificationDropdown" href="#" data-toggle="dropdown">
        <i class="icon-bell mx-0">{{ userNotifications.length }}</i>
    </a>
    <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list notification-dropdown" aria-labelledby="notificationDropdown">
        <p class="mb-0 font-weight-normal float-left dropdown-header">Notifications</p>
        <ng-container *ngFor="let notification of userNotifications">
            <a class="dropdown-item preview-item" (click)="handleNotificationClick(notification)">
                <div class="preview-thumbnail">
                    <ng-container *ngIf="notification.fileName !== null; else showAvatar">
                        <img [src]="getImageUrlNotifications(notification.userId, notification.fileName)" alt="profile" />
                    </ng-container>
                    <ng-template #showAvatar>
                        <div class="avatar" style="color: black;">{{ notification.username.charAt(0) }}{{ notification.username.charAt(1) }}</div>
                    </ng-template>
                </div>
                <div class="preview-item-content">
                    <div class="message-delete-container">
                        <div class="message-content">
                            <h6 class="preview-subject font-weight-normal">{{ notification.message }}</h6>
                            <p class="font-weight-light small-text mb-0 text-muted">{{ calculateTimeDifference(notification.timestamp) }}</p>
                        </div>
                        <button (click)="confirmDeleteNotification(notification.id)" class="btn btn-danger btn-sm delete-button">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </div>
            </a>
        </ng-container>
    </div>
</li>

      
      




      <li class="nav-item nav-profile dropdown">

        <div class="dropdown" (click)="toggleDropdown($event)">

          <a class="nav-link dropdown-toggle" data-toggle="dropdown" id="profileDropdown">
            <ng-container *ngIf="fileName !== null; else showAvatar">
              <img [src]="getImageUrl()" alt="profile" />
            </ng-container>
            <ng-template #showAvatar>
              <div class="avatar">{{ username?.charAt(0) }}{{ username?.charAt(1) }}</div>
            </ng-template>
          </a>
          <div class="dropdown-menu dropdown-menu-right navbar-dropdown" [ngClass]="{ 'show': dropdownOpen }"
            aria-labelledby="profileDropdown">
      
            <a class="dropdown-item" routerLink="profile">
              <i class="ti-settings text-primary" ></i>
              Settings
            </a>
            <a (click)="logout()" class="dropdown-item">
              <i class="ti-power-off text-primary"></i>
              Logout
            </a>
          </div>
        </div>
      </li>
      <li class="nav-item nav-settings d-none d-lg-flex">
        <a class="nav-link" href="#">
          <i class="icon-ellipsis"></i>
        </a>
      </li>
    </ul>
    <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
      data-toggle="offcanvas">
      <span class="icon-menu"></span>
    </button>
  </div>
</nav>